import { Injectable } from '@angular/core';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { HttpService } from '../../rest/http-service/http.service';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class FileUploadService {
    SERVER_URL = '/api/import';

    constructor(private httpService: HttpService<any>) {}

    postFile(file: File, parentResource: ResourceModel) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('parentPath', `${parentResource.path || ''}/${parentResource.name}`);

        return this.httpService.postFile(this.SERVER_URL, formData);
    }
}
